// extracted by mini-css-extract-plugin
export default {"delta":"deltaBadge_delta__AZnrp","arrow":"deltaBadge_arrow__ZT2aa","up":"deltaBadge_up__-fpor","down":"deltaBadge_down__ov+f4","flat":"deltaBadge_flat__KJimN"};